export default __webpack_public_path__ + "static/media/back.02e28fed.jpg";